<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <div class="row">
      <nfe-settings></nfe-settings>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import NfeSettings from './components/NfeSettings'
  import scroll from 'src/utils/scroll'

  export default {
    name: 'MainNfeSettings',
    components: { NfeSettings, Breadcrumb },
    data () {
      return {
        nfeSettings: {
          'nfeSettingDays': 11,
          'nfeSettingGenerate': 12
        },
        nfeSettingDays: '',
        nfeSettingGenerate: 0,
        municipalRegistration: '',
        index: '',
        crumbs: {
          'ico': 'ls-ico-cog',
          'section': this.$t('settings.main.nfe_settings'),
          'paths': {
            0: {
              'title': this.$t('settings.main.setup'),
              'path': ''
            }
          }
        }
      }
    },
    methods: {
      ...mapActions(['loadNfeSettings', 'updateNfeSetting', 'loadNfeSetting', 'setupSeller', 'loadSeller']),
      ...mapMutations(['setNfeSettings', 'clearFlash']),
      submitForm () {
        var paramsNfeDays = {id: this.nfeSettings.nfeSettingDays, value: this.nfeSettingDays}
        var paramsNfeGenerate = {id: this.nfeSettings.nfeSettingGenerate, value: +this.nfeSettingGenerate}
        var paramsSeller = {municipal_registration: this.municipalRegistration, gateway: {configs: this.gatewayFieldsValues, gateway_code: 'SP_MARILIA'}}

        this.$loader.show()
        this.updateNfeSetting(paramsNfeDays)
          .then(() => {
            this.updateNfeSetting(paramsNfeGenerate)
              .then(() => {
                if (this.nfeSettingGenerate === true) {
                  this.clearFlash()
                  this.setupSeller(paramsSeller)
                    .then(this.afterLoadNfeSetting)
                } else {
                  this.clearFlash()
                  this.afterLoadNfeSetting()
                }
              })
          })
      },
      afterLoadNfeSetting () {
        this.$loader.hide()
        scroll.scrollToFlash()
      },
      getNfeSettings () {
        let self = this
        this.loadNfeSetting(this.nfeSettings.nfeSettingDays).then(function (response) {
          self.nfeSettingDays = response
        })
        this.loadNfeSetting(this.nfeSettings.nfeSettingGenerate).then(function (response) {
          self.nfeSettingGenerate = response
          self.transformLoadSettingGenerate(response)
        }).then(this.afterLoadNfeSetting)
      },
      transformLoadSettingGenerate (value) {
        // '+' transforma em int e '!!' transforma em boolean
        this.nfeSettingGenerate = !!+value
      }
    },
    computed: {
      ...mapGetters(['nfeSetting', 'seller', 'gatewayFieldsValues'])
    },
    mounted () {
      this.getNfeSettings()
    }
  }
</script>



// WEBPACK FOOTER //
// MainNfeSettings.vue?10c6d594